import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { SVG } from '../svg/svg';
// TODO: Remove in future release. Package isn't bundled, so something _could_ be using this export
export var StyledSVG = styled(SVG)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var StyledPathDefault = styled.path(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    fill: ", ";\n"], ["\n    fill: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.logo.bgFill.default;
});
export var StyledPathBrand = styled.path(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    fill: ", ";\n"], ["\n    fill: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.logo.bgFill.brand;
});
var templateObject_1, templateObject_2, templateObject_3;
